export default __webpack_public_path__ + "static/media/de_ad_banner_v2.0a29ebf5.png";